// 引用组件
import SvgIcon from "~/components/SvgIcon.vue";

export default defineNuxtPlugin((nuxtApp) => {
  // 在Nuxt4中，我们使用nuxtApp.vueApp来访问Vue实例
  if (nuxtApp.vueApp) {
    // 注册全局组件，组建名为svg-icon
    nuxtApp.vueApp.component("svg-icon", SvgIcon);
  }
});
